import { getLink } from "../../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
      Al hejm’ mi venos laca, <br/>
      Jam kurba pro tristec’, <br/>
      Kiel demandosign’. <br/>
      Kaj du verdetaj tasoj <br/>
      Ektintos kontraŭ plet’ – <br/>
      Por mi kaj vi, <br/>
      Por vi kaj mi.
      </p>

      <p class="poem-block mb-3">
      Oscilos la pendolo, <br/>
      Serena venos lum’ <br/>
      Tra malfermita pord’. <br/>
      Kaj dum mi sidos sola <br/>
      En la duonobskur’, <br/>
      Mildiĝos la angor’, <br/>
      Mildiĝos la angor’.
      </p>

      <p class="poem-block mb-3">
      Kaj poste vi aperos <br/>
      El varma noktsilent’, <br/>
      La fantazia ombr’, <br/>
      Kaj en demando levos <br/>
      La brovojn kun atent’, <br/>
      Tamen sen vort’, <br/>
      Ne indas vort’.
      </p>

      <p class="poem-block mb-3">
      Kaj mi plenigos tasojn <br/>
      Per forta verda te’. <br/>
      Ni trinkos por plezur’. <br/>
      Kaj pri ofend’ dolora <br/>
      En mia rid’ postplora <br/>
      Ne pensu nur, <br/>
      Ne pensu nur.
      </p>

      <p class="poem-block mb-3">
      Forflugu tempo flue <br/>
      Tra faŭko de l’ horloĝ’, <br/>
      Ĉu gravas ja por ni? <br/>
      Ĉu la tempest’ rabias <br/>
      Aŭ nokt’ mistera pias <br/>
      Jam ĉirkaŭ ni? <br/>
      Jam ĉirkaŭ ni?   
      </p>

      <p class="poem-block mb-3">
      Nenio nin timigas, <br/>
      Kaj sur vespera tabl’ <br/>
      Lumadas la kandel’. <br/>
      Konversaci’ kaj teo, <br/>
      Kaj regas jam agrabl’ <br/>
      Pro varma te’, <br/>
      La verda te’.
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Verda teo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['LAZKs91DyQQ'],
    itemTranslator: translator.esp
  }
}

export default item;